import { LegacyTertiaryButton } from '#/components/LegacyButton/LegacyTertiaryButton';
import { BodyMicro } from '#/components/Text/BodyMicro';

type Props = {
  clearErrors: () => void;
  toggleSeparateFields: () => void;
  text: string;
  qaId?: string;
};

export function AllFieldToggle({
  clearErrors,
  toggleSeparateFields,
  text,
  qaId,
}: Props) {
  return (
    <LegacyTertiaryButton
      href="#"
      qaId={qaId}
      // oxlint-disable-next-line typescript/no-explicit-any
      onClick={(e: any) => {
        e.preventDefault();
        clearErrors();
        toggleSeparateFields();
      }}
    >
      <BodyMicro>{text}</BodyMicro>
    </LegacyTertiaryButton>
  );
}
